import { useState } from 'react'
import { useInterval } from 'usehooks-ts'

export const ReviewsSection: React.FC = () => {
  const reviews = [
    {
      name: 'M.I.',
      attr: 'ファミリー',
      heading: '箱を開けた瞬間、ボリュームにびっくり！',
      body: 'ひとつの花器に入りきらないことも（笑）見たことのない種類に出会えたりして楽しい。次は何が届くかな？と毎月の楽しみになっています。',
    },
    {
      name: 'R.S.',
      attr: 'ファミリー',
      heading: 'インテリアとして興味はあったけど',
      body: '枝ものをお店に買いに行くのはちょっとハードルが高かった。試してみたら、子どもも興味津々で「これなぁに？」と聞いてきます。お部屋で気軽に季節を感じることができるので嬉しいです。',
    },
    {
      name: 'Y.K.',
      attr: '1人暮らし',
      heading: '飾るだけで、部屋が変わった',
      body: '花屋で買うと持ち帰りが大変で…と思っていたら届くんですね。感動しました。飾るだけでこんなに部屋が変わるとは。',
    },
    {
      name: 'M.T.',
      attr: '1人暮らし',
      heading: '毎月届くのが楽しみに',
      body: '枝ものって難しそうと思っていたのに、花器に入れるだけでちゃんとサマになりました。毎月届くのが楽しみです。',
    },
    {
      name: 'H.T.',
      attr: '2人暮らし',
      heading: '選ばなくていいのがいい',
      body: '何を買えばいいか迷って結局買わない、というパターンを繰り返していたので、届くだけというのが自分には合っていました。',
    },
  ]

  const [current, setCurrent] = useState(0)

  useInterval(() => setCurrent((c) => (c + 1) % reviews.length), 8000)

  const prev = () => setCurrent((c) => (c - 1 + reviews.length) % reviews.length)
  const next = () => setCurrent((c) => (c + 1) % reviews.length)

  return (
    <section className="py-20 md:py-28 bg-bg px-5">
      <div className="max-w-2xl mx-auto">
        <div className="overflow-hidden">
          <div className="flex transition-transform duration-500 ease-in-out" style={{ transform: `translateX(-${current * 100}%)` }}>
            {reviews.map((r, i) => (
              <div key={i} className="w-full shrink-0 px-2 py-2">
                <h3 className="text-[22px] md:text-[28px] font-medium text-black leading-relaxed">{r.heading}</h3>
                <p className="mt-6 text-[15px] text-main leading-[1.9]">{r.body}</p>
                <p className="mt-6 text-[12px] text-dark-gray">
                  {r.name}さん（{r.attr}）
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 flex items-center justify-between">
          <div className="flex gap-2 items-center">
            {reviews.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                className={`rounded-full transition-all duration-300 ${i === current ? 'w-4 h-1.5 bg-black' : 'w-1.5 h-1.5 bg-gray/50'}`}
              />
            ))}
          </div>
          <div className="flex gap-2">
            <button onClick={prev} className="w-9 h-9 rounded-full border border-gray/60 flex items-center justify-center hover:border-black transition-colors">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="8 2 4 6 8 10" />
              </svg>
            </button>
            <button onClick={next} className="w-9 h-9 rounded-full border border-gray/60 flex items-center justify-center hover:border-black transition-colors">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="4 2 8 6 4 10" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}
